import { render, staticRenderFns } from "./ButtonFloat.vue?vue&type=template&id=12815a4e&"
import script from "./ButtonFloat.vue?vue&type=script&lang=js&"
export * from "./ButtonFloat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFloat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports